import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

function ClientWins() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    pauseOnHover: true,
  };

  const testimonials = [
    {
      quote: "I was overwhelmed trying to piece things together with Kajabi, Squarespace, and Google Drive. Ruth built me a seamless client portal that finally felt like mine.",
      name: "Emily Joanns, Marketing Specialists at Love and Wear"
    },
    {
      quote: "Woaom Web Design brought my community site to life — it’s beautiful and functional. Our members love it.",
      name: "Jelien Wicks, CEO of BetterBuilds"
    }
  ];

  return (
    <section className="bg-[#F7F3F2] py-20 px-6 md:px-16 lg:px-24">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-12">Client Wins</h2>

        <Slider {...settings}>
          {testimonials.map((t, idx) => (
            <div key={idx}>
              <blockquote className="text-lg md:text-xl text-gray-700 italic border-l-4 border-[#A7EF66] pl-6 pr-4 md:px-10">
                “{t.quote}”
                <span className="block mt-4 font-semibold text-[#333]">— {t.name}</span>
              </blockquote>
            </div>
          ))}
        </Slider>

        <a
          href="/clientwork"
          className="inline-block mt-10 text-sm font-semibold text-white bg-[#1A1A1A] hover:bg-[#333] px-6 py-3 rounded-full transition"
        >
           VIEW MORE RESULTS  →
        </a>
      </div>
    </section>
  );
}

export default ClientWins;
